module.exports = __webpack_public_path__ + "img/20220327_190834.db859348.jpg";